<template>
<aside class="app-sidebar">
    <el-menu router unique-opened :collapse='collapsed' :default-active="$route.path">
        <template v-for="item in showList">
            <el-menu-item :index="item.path" v-if="item.leaf">
                <div class="menu-inner">
                    <i class="icon" :class="item.icon"/>
                    <span class="title">{{$t('title.' + item.key)}}</span>
                </div>
            </el-menu-item>
            <el-submenu :index="item.path+''"  v-else>
                <template slot="title" style="padding: 0">
                    <div class="menu-inner">
                        <i class="icon" :class="item.icon"/>
                        <span class="title">{{$t('title.' + item.key)}}</span>
                    </div>
                </template>
                <el-menu-item v-for="(child, index) in item.children" :index="`${item.path}/${child.path}`" :key="index">
                    <div class="menu-inner child">
                        <span class="title">{{$t('title.' + child.key)}}</span>
                    </div>
                </el-menu-item>
            </el-submenu>
        </template>
    </el-menu>
</aside>
</template>

<script>
import Core from "../../../core";
import routes from "@/router/routes";



export default {
    name: 'AppSidebar',
    props: {
        collapsed: { type: Boolean, default: false }
    },
    data() {
        return {
            userType: Core.Data.getUserType(),
            userConfig: [],

            showList: [],
        }
    },
    created() {
        const user = Core.Data.getUser()
        console.log('user:', user)
        console.log('user:', user)
        let userConfig = []
        try {
            userConfig = JSON.parse(user.config)
            console.log('userConfig:', userConfig)
        } catch (error) {}
        this.userConfig = userConfig
        console.log('this.userConfig:', this.userConfig)

        this.getMenuList()
    },
    methods: {
        getMenuList() {
            let showList = routes.filter(item => {
                let meta = item.meta || {}
                return !meta.hidden && (!meta.role || meta.role.includes(this.userType)) && (!meta.auth || this.$auth(...meta.auth))
            });
            showList = showList.map(item => {
                let meta = item.meta || {}
                return {
                    key: meta.key,
                    name: item.name,
                    path: item.path,
                    icon: meta.icon || '',
                    leaf: meta.leaf || false,
                    children: item.children.filter(i => {
                        let i_meta = i.meta || {}
                        if (this.userConfig.length && !this.userConfig.includes(i.name)) {
                            return false
                        }
                        return !i_meta.hidden && (!i_meta.role || i_meta.role.includes(this.userType)) && (!i_meta.auth || this.$auth(...i_meta.auth))
                    }).map(i => {
                        let i_meta = i.meta || {}
                        return {
                            key: i_meta.key,
                            name: i.name,
                            path: i.path,
                        }
                    })
                }
            })
            if (this.userConfig.length) {
                showList = showList.filter(item => {
                    if (item.leaf) {
                        return this.userConfig.includes(item.name)
                    }
                    let children = item.children.map(i => i.name)
                    for (let i = 0; i < children.length; i++) {
                        const c = children[i];
                        if (this.userConfig.includes(c)) {
                            return true
                        }
                    }
                    return false
                });
            }
            console.log('showList:', showList)
            this.showList = showList
        }
    },
}
</script>

<style lang="scss">
.app-sidebar {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    background: #FFFFFF;
    .el-menu {
        width: 200px;
        &.el-menu--collapse {
            width: 78px;
        }
        height: 100%;
        border-right: 1px solid rgba(82, 91, 104, 0.2);
        background: #fff;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 2px;
            height: 6px;
        }
        &::-webkit-scrollbar-thumb {
            /*滚动条内部滑块*/
            border-radius: 3px;
            background-color: rgba(144, 146, 152, 0.3);
            transition: background-color 0.3s;
            &:hover {
                background: #bbb;
            }
        }
        &::-webkit-scrollbar-track {
            /*滚动条内部轨道*/
            background: #ededed;
        }
        .menu-inner {
            color: #8090a6;
            font-size: 13px;
            @include fac();
            height: 100%;
            i.icon {
                font-size: 14px;
                display: inline-block;
                margin-left: 12px;
                margin-right: 10px;
                color: inherit;
                line-height: 1;
            }
            &.child .title {
                padding-left: 18px;
            }
        }
        .el-menu-item.is-active {
            background: #155BD4;
            .menu-inner {
                color: #fff;
            }
        }
        .el-submenu {
            &.is-opened {
                background: #F3F6F8;
                ul.el-menu {
                    background: #F3F6F8;
                    .el-menu-item {
                        background: #F3F6F8;
                        &:hover {
                            background-color: #e8effb;
                        }
                        &.is-active {
                            background-color: #155BD4;
                        }
                    }
                }
            }
            &.is-active:not(.is-opened) {
                .el-submenu__title {
                    background-color: #155BD4;
                    .menu-inner {
                        color: #fff;
                    }
                    .el-submenu__icon-arrow {
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>
